import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import AudioPlayer from 'components/AudioPlayer';
import audioNo from 'assets/sounds/no/Introduksjon-sprakforstaelse.mp3';
import audioNn from 'assets/sounds/nn/Introduksjon-sprakforstaelse.mp3';
const languageObj = {
	no: audioNo,
	nn: audioNn,
};

class Intro extends React.Component {
	constructor(props) {
		super(props);
		this.audio = languageObj[strings.getLanguage()];
		/* this.video = videoBiltoPil; */
	}

	render() {
		const {onNextStep} = this.props;
		let videoRef;
		return (
			<div>
				<p>
					<AudioPlayer
						/* onStart={() => {
							videoRef.play();
						}} */
						onErrorPlay={() => {
							console.log('Something went wrong');
						}}
						autoplay
						inline
						src={this.audio}
					/>
					{strings.sprakforstaelse}
				</p>
				{/* <div className="lit-preview">
					<p className="lit-preview__label">{'Eksempel'}</p>
					<video
						className="lit-preview__video"
						loop
						ref={(ref) => {
							videoRef = ref;
						}}
						src={this.video}
					/>
				</div> */}

				<button
					className="lit-btn bg-primary"
					onClick={() => {
						this.props.onShowAvatar(false);
						onNextStep();
					}}
				>
					{strings.toPractice}
				</button>
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Intro);
